import { render, staticRenderFns } from "./CreatedDept.vue?vue&type=template&id=6305d784&scoped=true"
import script from "./CreatedDept.vue?vue&type=script&lang=js"
export * from "./CreatedDept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6305d784",
  null
  
)

export default component.exports